import { isAddress } from '@ethersproject/address';
import { AddressZero } from '@ethersproject/constants';
import { Contract, ContractInterface } from '@ethersproject/contracts';
import { JsonRpcProvider } from '@ethersproject/providers';

/**
 * Returns a new instance of the Contract class for the specified contract address and ABI,
 * using the specified JSON-RPC provider, and an optional account for signing.
 * @param {string} address The address of the contract.
 * @param {ContractInterface} ABI The ABI (Application Binary Interface) for the contract.
 * @param {JsonRpcProvider} provider The JSON-RPC provider to use for interacting with the blockchain.
 * @param {string} [account] Optional account address for signing transactions.
 * @returns {Contract} A new instance of the Contract class for the specified contract address and ABI.
 * @throws {Error} If the address is invalid.
 */
export const getContract = (
  address: string,
  ABI: ContractInterface,
  provider: JsonRpcProvider,
  account?: string
): Contract => {
  if (!isAddress(address) || address === AddressZero) {
    throw Error(`Invalid 'address' parameter '${address}'.`);
  }
  const providerOrSigner = account ? provider.getSigner(account).connectUnchecked() : provider;
  return new Contract(address, ABI, providerOrSigner as any);
};
